<template>
  <div class="collection">
    <div class="top">
      <p class="headline">{{ headline }}</p>
      <div class="filters">
        <ul
          class="filters__list"
          :class="{ 'filters__list--open': filterOpen }"
        >
          <li
            class="filters__filter"
            :class="{ 'filters__filter--active': data.handle === allHandle }"
          >
            <a :href="allUrl" @click.prevent="ajaxLoad(allUrl)">
              {{ $translations.products.collection.view_all }}
            </a>
          </li>
          <li
            v-for="filter in filters"
            :key="filter.handle"
            class="filters__filter"
            :class="{
              'filters__filter--active': data.handle === filter.handle,
            }"
          >
            <a :href="filter.url" @click.prevent="ajaxLoad(filter.url)">{{
              filter.title
            }}</a>
          </li>
        </ul>
        <button class="filters__button" @click="filterOpen = !filterOpen">
          {{ $translations.products.collection.filter }}
          <span v-show="filterOpen"><i class="fal fa-chevron-up"/></span>
          <span v-show="!filterOpen"><i class="fal fa-chevron-down"/></span>
        </button>
      </div>
    </div>

    <div class="grid" :class="{ 'grid--loading': ajaxLoading }" v-html="products"></div>

    <ul class="pagination">
      <li
        v-for="part in data.pagination.parts"
        :key="part.title"
        class="pagination__part"
        :class="{
          'pagination__part--active':
            part.title === data.pagination.current_page,
        }"
      >
        <a
          :href="part.url"
          @click.prevent="ajaxLoad(part.url)"
          v-html="part.title"
          v-if="part.is_link"
        />
        <span v-html="part.title" v-else />
      </li>
    </ul>
  </div>
</template>

<script>
import shopifyAjax from "../mixins/shopifyAjax";

export default {
  mixins: [shopifyAjax],
  name: "Collection",
  selector: "#vue-collection",
  props: {
    initialData: {
      type: Object,
      required: true,
    },
    filters: {
      type: Array,
      required: true,
    },
    allHandle: {
      type: String,
      required: true,
    },
    allUrl: {
      type: String,
      required: true,
    },
    headline: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      filterOpen: false,
      data: this.initialData,
    };
  },
  computed: {
    products() {
      return this.data.products
    },
  },
  watch: {
    products() {
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('app:remount'));
      }, 1)
    },
  }
};
</script>

<style lang="scss" scoped>
.collection {
  margin-top: 64px;
  @include inner-container();
}

.top {
  display: flex;
  align-items: center;

  @include media("<=tablet") {
    flex-direction: column;
    align-items: stretch;
    text-align: center;
  }
}

.headline {
  font-weight: 700;
  margin: 0;
  font-size: 21px;
}

.filters {
  margin-left: 48px;
  font-size: 14px;

  @include media("<=tablet") {
    margin-left: 0;
  }

  &__button {
    display: none;

    @include media("<=tablet") {
      @include button-reset();
      margin-top: 32px;
      display: inline-block;
      font-size: 14px;
    }
  }

  &__list {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;

    @include media("<=tablet") {
      margin-top: 32px;
      display: none;
      &--open {
        display: block;
      }
    }
  }

  &__filter {
    a {
      color: $black;
      text-decoration: none;
    }

    &--active {
      font-weight: 700;
    }

    & + & {
      margin-left: 16px;

      @include media("<=tablet") {
        margin-left: 0;
        margin-top: 16px;
      }
    }
  }
}

.grid {
  margin-top: 56px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
  grid-template-rows: repeat(4, auto);
  grid-column-gap: 32px;
  grid-row-gap: 76px;
  transition: opacity 0.2s ease-out;

  &--loading {
    opacity: 0;
  }

  @include media("<=tablet") {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    grid-template-rows: auto;
    grid-column-gap: 24px;
  }

  @include media("<=phone") {
    grid-column-gap: 16px;
  }
}

.pagination {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  justify-content: center;

  &__part {
    border-radius: 4px;
    background-color: transparent;
    padding: 8px 12px;
    font-size: 20px;
    transition: background-color 0.15s ease-in-out;

    & + & {
      margin-left: 16px;
    }

    a {
      color: $black;
      text-decoration: none;
    }

    &:hover {
      background-color: rgba($teal, 0.1);
    }
    &--active {
      background-color: $teal;
      color: $white;
      &:hover {
        background-color: $teal;
      }
    }
  }
}
</style>
